export const PRODUCT_ASSETS_URL = 'https://assets.futrli.com/';

export const XERO_LOGO = `${PRODUCT_ASSETS_URL}xero.svg`;
